import axios from 'axios'

const API_URL = process.env.VUE_APP_API_BASE_URL
const API_ROOT = API_URL + 'Import/'

class ImportService {
  getApplicableImportTypes () {
    return axios.get(API_ROOT + 'ApplicableImportTypes', { showLoader: false })
  }
}

export default new ImportService()
